import styled from "@emotion/styled";
import { yupResolver } from "@hookform/resolvers/yup";
import { ChargeSaleLeadRequest, postContactUsChargeLeadRequest } from "api";
import ContactUsState from "components/ContactUs/ContactUsState";
import FormInputCharge from "pazChargeComponents/general/FormInputCharge";
import { createRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { trackFormSubmition, trackUserFocusFiledOnForm } from "reusable/ChargeGTM";
import { schemaCommon } from "reusable/Form/FormSchema";
import colors from "theme/colors";
import { ButtonWithArrow, NewText } from "ui";
import { sharedColors } from "ui/theme/colors";
import { getUtmParams } from "utils";
import * as yup from "yup";
import FormSucessMessage from "./FormSucessMessage";

const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY
if (!RECAPTCHA_KEY) {
    throw new Error("Please provide the RECAPTCHA_KEY environment variable.")
}
const StyledWrapper = styled.div`
    width: 100%;    
    ${(props) => props.theme.breakpoints.up("md")} {
        width: 420px;   
      }
`
const StyledFormDiv = styled.div`
padding-bottom: 30px;
  height: 100%;
  form {
    display: flex;
    flex-direction: column;
    .MuiAutocomplete-endAdornment {
      top: unset;
      ${(props) => props.theme.breakpoints.up("md")} {
        transform: none;
      }
    }
  }
`
const StyledTextWrapper = styled.div`
padding-top: 8px;
  height: 44px;
  display: flex;
//   align-items: center;
  p {
    margin-left: 8px;
  }
`
const Asterisk = styled.span<{ $marginBottom?: number }>`
  color: ${sharedColors.blue};
  margin-bottom: ${(p) => (p.$marginBottom ? `${p.$marginBottom}px` : "0px")};
  width: 4px;
`
const StyledButtonWrapper = styled.div`
  padding-top: 40px;
`
const StyledDivWrapper = styled.div`
  width: 100%;
  display: grid;
  row-gap: 25px;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr;
    gap: 21px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    row-gap: 50px;  
  }
  grid-template-columns: 1fr;

    & .MuiFormLabel-asterisk: {
    color: "red", // Set your desired color for the asterisk here
  },
`
const StyledFiedlset = styled.fieldset`
padding: 0;
margin: 0;
border: none;
    display: flex;
    flex-direction: column;
    gap: 25px;
`
const HiddenAccessiblityText  = styled('span')`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const schema = yup.object({
    firstName: schemaCommon.firstName,
    lastName: schemaCommon.lastName,
    ID: schemaCommon.IndividualID,
    phoneNumber: schemaCommon.phoneNumber,
    remarks: schemaCommon.remarks,
})
interface IFormInputs {
    firstName: string
    lastName: string
    ID: string
    phoneNumber: string
    remarks: string
}
type Props = {
    data: any
}
function ChargeForm({ }: Props) {

    const [isSuccess, setIsSuccess] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const reCaptchaRef = createRef<ReCAPTCHA>()

    const {
        handleSubmit,
        control,
        formState,
        setValue,
        trigger,
        reset,
    } = useForm({
        defaultValues: {
            firstName: "",
            lastName: "",
            ID: "",
            phoneNumber: "",
            remarks: "",
        },
        resolver: yupResolver(schema),
    })
    const { errors, isValid, isSubmitted} = formState

    const onSubmit: SubmitHandler<IFormInputs> = async (data) => {
        setIsLoading(true)
        reCaptchaRef?.current?.reset()
        const recaptchaResponse =
            (await reCaptchaRef?.current?.executeAsync()) as string
        const { Campaign, Source, Medium, Term, Content, Fbclid, Gclid, PageUrl, } = getUtmParams()
        const postData: ChargeSaleLeadRequest = {
            CustomerId: parseInt(data.ID),
            Mail: "notavailible@gmail.com",
            FirstName: data.firstName,
            LastName: data.lastName,
            PhoneNumber: data.phoneNumber,
            ChargingType: "",
            Remarks: data.remarks,
            AgreeNewsletter: false,
            UtmSource: Source,
            UtmMedium: Medium,
            UtmCampaign: Campaign,
            UtmTerm: Term,
            UtmContent: Content,
            FbClId: Fbclid,
            GclId: Gclid,
            Town: "",
            PageUrl: PageUrl,
            GRecaptchaResponse: recaptchaResponse
        }
        try {
            const response = await postContactUsChargeLeadRequest("", postData) as any
            if (response?.data?.Body && !response.data.errorCode) {
                setIsOpen(true)
                setIsSuccess(true)
                trackFormSubmition()
                reset();
            } else {
                setIsOpen(true)
                setIsSuccess(false)
            }
        } catch (error) {
            reset();
            setIsOpen(true)
            setIsSuccess(false)
        } finally {
            setIsLoading(false)
        }
    }
    const handleUserFocusField = (fieldName: string) => {
        trackUserFocusFiledOnForm(fieldName)
    }

    if (isSuccess) {
        return <FormSucessMessage />
    }
    return (
        <StyledWrapper>
            <NewText
                desktopFontSize={28}
                desktopLineHeight={"32px"}
                mobileFontSize={28}
                mobileLineHeight={"32px"}
                desktopFontWeight={500}
                mobileFontWeight={500}
                component={"h2"}
            >
                השאירו פרטים ונחזור אליכם
            </NewText>
            <StyledTextWrapper>
                <Asterisk>*</Asterisk>
                <NewText
                    component={"p"}
                    largeDesktopFontSize={16}
                    largeDesktopLineHeight={"24px"}
                    desktopFontWeight={400}
                    desktopFontSize={12}
                    desktopLineHeight="18px"
                    mobileFontSize={16}
                    mobileLineHeight={"24px"}
                >
                    שדות המסומנים בכוכב הם שדות חובה
                </NewText>
            </StyledTextWrapper>
            <StyledFormDiv>

                <form onSubmit={handleSubmit(onSubmit)} style={{ height: "100%" }}>
                    <StyledFiedlset aria-label="טופס צור קשר">
                        <StyledDivWrapper>
                            <Controller
                                name="firstName"
                                control={control}
                                render={({ field }) => (
                                    <FormInputCharge
                                        field={field}
                                        error={errors.firstName?.message}
                                        placeholder="first name"
                                        type="text"
                                        required={true}
                                        inputProps={{ fullWidth: true, style: { width: "100%", height: 40 } }}
                                        fullWidth
                                        textColor={sharedColors.black}
                                        onFocus={() => handleUserFocusField(field.name)}
                                        label={<LocalInputLabel
                                            isErrored={errors.firstName?.message !== undefined}
                                            text="שם פרטי"
                                        />}
                                        withAsterisk={false}
                                    />
                                )}
                            />
                            <Controller
                                name="lastName"
                                control={control}
                                render={({ field }) => (
                                    <FormInputCharge
                                        field={field}
                                        error={errors.lastName?.message}
                                        type="text"
                                        required={true}
                                        fullWidth
                                        textColor={sharedColors.black}
                                        onFocus={() => handleUserFocusField(field.name)}
                                        inputProps={{ style: { height: 40 } }}
                                        withAsterisk={false}
                                        label={<LocalInputLabel
                                            isErrored={errors.lastName?.message !== undefined}
                                            text="שם משפחה"
                                        />}
                                    />
                                )}
                            />
                        </StyledDivWrapper>
                        <Controller
                            name="phoneNumber"
                            control={control}
                            render={({ field }) => (
                                <FormInputCharge
                                    field={field}
                                    error={errors.phoneNumber?.message}
                                    type="number"
                                    required={true}
                                    fullWidth
                                    textColor={sharedColors.black}
                                    onFocus={() => handleUserFocusField(field.name)}
                                    withAsterisk={false}
                                    inputProps={{ style: { height: 40 } }}
                                    label={<LocalInputLabel
                                        isErrored={errors.phoneNumber?.message !== undefined}
                                        text="טלפון נייד"
                                    />}
                                />
                            )}
                        />
                        <Controller
                            name="ID"
                            control={control}
                            render={({ field }) => (
                                <FormInputCharge
                                    field={field}
                                    error={errors.ID?.message}
                                    type="number"
                                    required={true}
                                    fullWidth
                                    textColor={sharedColors.black}
                                    onFocus={() => handleUserFocusField(field.name)}
                                    withAsterisk={false}
                                    inputProps={{ style: { height: 40 } }}
                                    label={<LocalInputLabel
                                        isErrored={errors.ID?.message !== undefined}
                                        text="ת.ז / ח.פ"
                                    />}
                                />
                            )}
                        />
                        <Controller
                            name="remarks"
                            control={control}
                            render={({ field }) => (
                                <FormInputCharge
                                    field={field}
                                    error={errors.remarks?.message}
                                    type="text"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    textColor={sharedColors.black}
                                    onFocus={() => handleUserFocusField(field.name)}
                                    withAsterisk={false}
                                    label={<LocalInputLabel
                                        isErrored={errors.remarks?.message !== undefined}
                                        text="איך נוכל לעזור?"
                                        requierd={false}
                                    />}

                                />
                            )}
                        />
                        <StyledButtonWrapper>
                            <ButtonWithArrow
                                desktopHeight={40}
                                desktopWidth={260}
                                desktopFontSize={16}
                                smallDesktopFontSize={12}
                                mobileFontSize={16}
                                mobileHeight={40}
                                mobileWidth={178}
                                desktopFontWeight={500}
                                justifyContent="center"
                                title={"חיזרו אליי"}
                                textColor={colors.white}
                                backgroundColor={colors.blue}
                                svgRelative
                                type="submit"
                                disabled={isLoading}
                            />
                        </StyledButtonWrapper>
                        {RECAPTCHA_KEY && (
                            <ReCAPTCHA
                                ref={reCaptchaRef}
                                sitekey={RECAPTCHA_KEY}
                                size="invisible"
                                hl="iw"
                                tabIndex={-1}
                            />
                        )}

                    </StyledFiedlset>
                    {isSubmitted && !isValid && (
                        <HiddenAccessiblityText role="alert">
                            There are errors in the form. Please correct them before submitting.
                        </HiddenAccessiblityText>
                    )}
                </form>
                <ContactUsState
                    center
                    isOpen={isOpen}
                    isSuccess={isSuccess}
                    setIsOpen={setIsOpen}
                />
            </StyledFormDiv>
        </StyledWrapper>
    );
}

type InputLabelProps = {
    isErrored: boolean
    text: string,
    requierd?: boolean
}
const LocalInputLabel = ({ isErrored = false, text, requierd = true }: InputLabelProps) => {
    return (
        <div>
            {requierd &&
                <span style={{ verticalAlign: "-webkit-baseline-middle", color: isErrored ? colors.darkRed : colors.blue, paddingLeft: 3 }}>
                    *
                </span>
            }
            {text}
        </div>
    )
}

export default ChargeForm;
